var POPUP_CLOSE_MESSAGE = 'CLOSE';
var STATIC_POPUP_WINDOW_PARAMS = 'toolbar=no,menubar=yes,modal=yes,alwaysRaised=yes,location=no,resizable=yes,scrollbars=yes,status=yes';
function extractOrigin(url) {
    var match = /^(https?:\/\/[\-_a-zA-Z\.0-9:]+)/.exec(url);
    if (match) {
        return match[1];
    }
    return url;
}
// for opening popups related to app config:
function openPopup(url, width, height, callback) {
    var origin = extractOrigin(url);
    var windowTop = (typeof screen === 'object' ? (screen.height - height) * 0.5 : 0);
    var windowLeft = (typeof screen === 'object' ? (screen.width - width) * 0.5 : 0);
    var windowParams = STATIC_POPUP_WINDOW_PARAMS + ',height=' + height + ',width=' + width + ',top=' + windowTop + ',left=' + windowLeft;
    var popup;
    var closeTimer;
    closeTimer = setInterval(function () {
        if (popup && popup.closed) {
            cleanup();
            if (callback) {
                callback(new Error('POPUP_CLOSED'));
                callback = null;
            }
            return;
        }
    }, 500);
    popup = window.open(url, 'popup' + Date.now(), windowParams);
    function cleanup() {
        if (closeTimer) {
            clearInterval(closeTimer);
            closeTimer = null;
        }
        if (popup) {
            try {
                popup.close();
            }
            catch (securityViolation) {
                // tell popup to close itself
                popup.postMessage(POPUP_CLOSE_MESSAGE, origin);
            }
        }
        popup = null;
        window.removeEventListener('message', onMessage, false);
        window.removeEventListener('unload', cleanup, false);
    }
    function onMessage(e) {
        // disable check origin for popup / postMessage to allow dev team
        // integrate their external link with more flexible
        // if (e.origin !== origin && (e.origin !== window.location.origin && e.origin !== config.appBackendHerokuOrigin && e.origin !== config.appBackendOrigin) ) { return; }
        var data;
        try {
            data = JSON.parse(e.data);
        }
        catch (err) {
            return;
        }
        if (data.type === 'error') {
            cleanup();
            if (callback) {
                callback(data.payload);
                callback = null;
            }
        }
        else if (data.type === 'success') {
            cleanup();
            if (callback) {
                callback(null, data.payload);
                callback = null;
            }
        }
    }
    window.addEventListener('message', onMessage, false);
    window.addEventListener('unload', cleanup, false);
    // hack so we can access popup later
    cleanup.popup = popup;
    return cleanup;
}
export default {
    openPopup: openPopup,
};
//# sourceMappingURL=popup.js.map